import { PromptModal } from '@/components'
import { UserProfileLink } from '@/modules/users/UserProfile/UserProfileLink'
import type { UserNode } from '@/modules/users'
import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'

interface Props {
  nonResponders: Pick<UserNode, 'id' | 'fullName'>[]

  onSubmit: PromptResolve<null>
}

/** Who the organiser is still waiting on, opened from the registration bar. */
export const EventNonRespondersPrompt: React.FC<Props> = ({
  nonResponders,
  onSubmit,
}) => {
  const translations = useTranslate({
    title: 'events.not-answered',
    nobody: 'events.everybody-answered',
    close: 'common.close',
  })

  return (
    <PromptModal
      title={`${translations.title} (${nonResponders.length})`}
      submitText={translations.close}
      className="w-[440px]"
      cancelOnClickOutside
      cancelOnEscape
      onCancel={() => onSubmit(null)}
      onSubmit={() => onSubmit(null)}
    >
      {nonResponders.length === 0 ? (
        <p className="m-0 text-sm text-stone-500">{translations.nobody}</p>
      ) : (
        <ul className="m-0 flex list-none flex-col gap-2 p-0">
          {nonResponders.map(user => (
            <li key={user.id} className="text-sm">
              <UserProfileLink user={user} />
            </li>
          ))}
        </ul>
      )}
    </PromptModal>
  )
}
